import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-dynamic-joint-ownership',
    templateUrl: './dynamic-joint-ownership.component.html',
    styleUrls: ['./dynamic-joint-ownership.component.scss'],
    standalone: false
})
export class DynamicJointOwnershipComponent implements OnInit {
  @Input() public myUser;
  @Input() public ownersList = [];
  @Input() public isDe;
  @Input() public invalid: string;
  @Input() public fieldId = '';
  @Input() public errorMessage;
  @Output() newOwnershipObjectToEmit = new EventEmitter<any>();

  public ownershipTypeList: Array<Object> = [
    { type: 'Joint Tenant', value: 'joint' },
    { type: 'Tenants in common', value: 'common' },
  ];
  public error: any;
  public ownershipTypeSelected: any = this.ownershipTypeList[0]['type']
  public ownershipSum: number = 0;
  public selectValue: any;
  public defaultOwner: any;
  public ownershipTypeItem: string;
  public jointOwnersArrayToSend: Array<any> = [];
  sumTotalShares: any;

  constructor() {
  }

  ngOnInit() {
    // console.log('ngOnInit() ownerList - ', this.ownersList);
    let o: any;
    for (o of this.ownersList) {
      if (o && o.share > 0) {
        this.ownershipTypeSelected = 'common';
        return;
      } else {
        this.ownershipTypeSelected = 'joint';
        return;
      }
    }
  }

  checkOwnerType(ownershipTypeSelected) {
    // console.log('checkOwnerType(), ownershipTypeSelected -> ', ownershipTypeSelected)
    if (ownershipTypeSelected === 'joint') {
      // console.log('checkOwnerShare(), ownersList - ', this.ownersList)
      let o: any;
      for (o of this.ownersList) {
        if (o && o.share) {
          o.share = null
          this.newOwnershipObjectToEmit.emit({
            newJointOwnershipToSend: this.ownersList,
            fieldId: this.fieldId
          });
        }
      }
    }
  }

  checkOwnerShare(data) {
    // console.log('checkOwnerShare(), ownersList - ', this.ownersList)
    this.sumTotalShares = this.ownersList.map(item => item.share).reduce((prev, curr) => prev + curr, 0);
    // console.log(this.sumTotalShares)
    if (this.sumTotalShares > 100) {
      this.error = 'Total ownership must equal precisely 100 percent.';
      this.newOwnershipObjectToEmit.emit({
        newJointOwnershipToSend: this.ownersList,
        fieldId: this.fieldId,
        error: this.error
      });
    } else {
      this.newOwnershipObjectToEmit.emit({
        newJointOwnershipToSend: this.ownersList,
        fieldId: this.fieldId,
        error: this.error
      });
      this.error = undefined
    }
  }
}
